export default __webpack_public_path__ + "static/media/chrome-icon.0a9fd96a.svg";